import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import LayoutGeneral from '../LayoutGeneral';
import './LoginResetPassword.css';
import cargando from '../Imagenes/Cargando.gif';
import { RUTAS_LOGIN } from "../Rutas";

const LoginResetPassword = () => {
  const navigate = useNavigate();
  const [correo, setCorreo] = useState('');
  const [nuevaPass, setNuevaPass] = useState('');
  const [confirmarPass, setConfirmarPass] = useState('');
  const [codigo, setCodigo] = useState(['', '', '', '']); // Token declarado en 4 arreglos
  const [mensajeConfirmacion, setMensajeConfirmacion] = useState('');

  const inputsRef = useRef([]);

  // Lee el email desde el query string al cargar
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const emailParam = params.get('email');
    if (emailParam) {
      setCorreo(emailParam);
    }
  }, []);

  // Manejo de cambio en los inputs del token
  const handleTokenChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return; // Solo números
    const newCodigo = [...codigo];
    newCodigo[index] = value;
    setCodigo(newCodigo);

    // Pasa al siguiente input automáticamente
    if (value !== '' && index < 3) {
      inputsRef.current[index + 1].focus();
    }
  };

  // Manejo de retroceso para moverse al anterior
  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && codigo[index] === '' && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const manejarSubmit = async (e) => {
    e.preventDefault();
    const tokenCompleto = codigo.join('');

    // Validaciones
    if (!nuevaPass || !confirmarPass || tokenCompleto.length !== 4) {
      setMensajeConfirmacion('❌ Error: Por favor completa todos los campos correctamente.');
      return;
    }
    if (nuevaPass !== confirmarPass) {
      setMensajeConfirmacion('❌ Error: Las contraseñas no coinciden.');
      return;
    }

    try {
      const response = await fetch(RUTAS_LOGIN.UPDATE_PASS, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          correo: correo,
          password: nuevaPass,
          codigo: tokenCompleto
        })
      });

      if (response.status === 200) {
        setMensajeConfirmacion('✅ Contraseña restablecida correctamente.');
        setTimeout(() => {
          navigate('/');
        }, 3800);
      } else if (response.status === 409) {
        setMensajeConfirmacion('❌ Usuario o código incorrecto.');
      } else if (response.status === 500) {
        setMensajeConfirmacion('❌ Error, inténtelo más tarde.');
      } else {
        console.error('Error inesperado:', response);
        setMensajeConfirmacion('❌ Error inesperado.');
      }
    } catch (error) {
      setMensajeConfirmacion('❌ Error de conexión con el servidor.');
    }
  };

  return (
    <LayoutGeneral titulo="Restablecer Contraseña">
      <div className="reset-container">
        <form onSubmit={manejarSubmit} className="reset-form">
          
          {/* Email (solo lectura) */}
          <input
            type="email"
            value={correo}
            readOnly
            className="form-control soloLectura mb-3"
          />

        <hr />

          {/* Nueva contraseña */}
          <input
            type="password"
            placeholder="Nueva contraseña"
            value={nuevaPass}
            onChange={(e) => setNuevaPass(e.target.value)}
            className="form-control mb-3"
          />

          {/* Confirmar contraseña */}
          <input
            type="password"
            placeholder="Confirmar nueva contraseña"
            value={confirmarPass}
            onChange={(e) => setConfirmarPass(e.target.value)}
            className="form-control mb-3"
          />
        
        <hr />
          <center><label> Token de Autorización </label></center><br />
          {/* Token en 4 cuadritos */}
          <div className="d-flex justify-content-center gap-2 mb-3">
            {codigo.map((val, i) => (
              <input
                key={i}
                type="text"
                maxLength="1"
                value={val}
                onChange={(e) => handleTokenChange(e.target.value, i)}
                onKeyDown={(e) => handleKeyDown(e, i)}
                ref={(el) => (inputsRef.current[i] = el)}
                className="form-control text-center"
                style={{
                  width: '60px',
                  height: '60px',
                  fontSize: '24px',
                  borderRadius: '10px'
                }}
              />
            ))}
          </div>

          {/* Botón de guardar */}
          <button type="submit" className="btn btn-primary w-100">
            Guardar nueva contraseña
          </button>
        </form>
      </div>
      <br />
      {mensajeConfirmacion && (
        <div className="alert alert-info mt-4"> 
            <span>{mensajeConfirmacion}</span>

            {/* Solo mostramos la imagen si el mensaje es de éxito */}
            {mensajeConfirmacion.startsWith('✅') && (
                <img className="cargando-image mb-5" src={cargando} alt="Cargando..." />
            )}
            {mensajeConfirmacion.startsWith('✅') && (
                <span> Redirigiendo... </span>
            )}
        </div>
        )}
    </LayoutGeneral>
  );
};

export default LoginResetPassword;
